import { Component, OnInit, AfterViewInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import * as HSET from "./settings";
import { WidgetStatusPieBreakupService } from './service/widget-status-pie-breakup.service';

@Component({
  selector: 'widget-status-pie-breakup',
  templateUrl: './widget-status-pie-breakup.component.html',
  styleUrls: ['./widget-status-pie-breakup.component.scss'],
  providers: [WidgetStatusPieBreakupService]
})
export class WidgetStatusPieBreakupComponent 
implements OnInit, AfterViewInit, OnChanges {
  @Input() FILTERS;
  @Input() OPTIONS;
  @Input() TITLE;

  dropdownItems = ["All"];
  highcharts: typeof Highcharts = Highcharts;
  chartOptions = null;
  errorMessage = "";
  mockChart = null;
  Alldata;

  constructor(
    private translateService: TranslateService,
    private dataService: WidgetStatusPieBreakupService
  ) {}

  ngAfterViewInit() {
    this.getInTransitStatus();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
        JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
      this.getInTransitStatus();
    }
  }

  ngOnInit() {
    this.translateService
      .get("OVERALL_STATUS.STATUS_BREAKUP")
      .subscribe(text => {
        this.TITLE = this.TITLE || text;
      });
  }

  getInTransitStatus() {
    this.chartOptions = null;
    this.errorMessage = "";
    this.mockChart = null;
    this.dataService
      .getInTransitStatus(this.OPTIONS.api, this.FILTERS)
      .subscribe(
        chartData => {
          
          if (chartData && chartData.series && chartData.series.length) {
            chartData.series.map(data => {
              this.dropdownItems.push(data[0]);
            });
            this.chartOptions = this.dataService.createChart(
              chartData,
              this.OPTIONS
            );
            this.Alldata = chartData;
          } else {
            this.errorMessage = "ERROR_MSG.NO_DATA";
            this.mockChart = HSET.chartData;
          }
        },
        error => {
          this.errorMessage = "ERROR_MSG.SYSTEM_ERROR";
          this.mockChart = HSET.chartData;
        }
      );
  }

  public dropdownChange(value: any): void {
    if (value !== "All") {
      const newCahrdata = { series: [], total: this.Alldata.total };
      const filter = this.Alldata.series.filter(data => data[0] === value);
      newCahrdata.series = filter;
      this.chartOptions = this.dataService.createChart(
        newCahrdata,
        this.OPTIONS
      );
    } else {
      this.chartOptions = this.dataService.createChart(
        this.Alldata,
        this.OPTIONS
      );
    }
  }
}